/**
 * Vertical Navigation Context for UI-Model-1
 *
 * Manages the active tab state for the main editor (Layout/CSS/Theme)
 */

import React, { createContext, useContext, useState, PropsWithChildren } from 'react';
import { VerticalTabType, VerticalNavContextType } from '../types/navigation.types';
import { VERTICAL_TABS } from '../constants/navigation';

const initialState: VerticalNavContextType = {
  activeTab: VERTICAL_TABS.LAYOUT as VerticalTabType,
  setActiveTab: () => {},
};

export const VerticalNavContext = createContext<VerticalNavContextType>(initialState);

export const VerticalNavProvider = ({ children }: PropsWithChildren) => {
  const [activeTab, setActiveTab] = useState<VerticalTabType>(
    VERTICAL_TABS.LAYOUT as VerticalTabType
  );

  const handleSetActiveTab = (tab: VerticalTabType) => {
    setActiveTab(tab);
  };

  return (
    <VerticalNavContext.Provider
      value={{
        activeTab,
        setActiveTab: handleSetActiveTab,
      }}
    >
      {children}
    </VerticalNavContext.Provider>
  );
};

export const useVerticalNav = () => {
  const context = useContext(VerticalNavContext);
  if (!context) {
    throw new Error('useVerticalNav must be used within a VerticalNavProvider');
  }
  return context;
};
